import { useIsAuth } from "../../hooks/useIsAuth"
import Layout from "../components/Layout";
import { ListHeader } from "../components/ListHeader";
import { DefaultButton } from "../components/DefaultButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/mainReducer";
import ResponsiveTable, { TableHeaders } from "../components/ResponsiveTable";
import { useState, useEffect } from 'react';
import { sistemaActions } from "../recucer";
import { ListInput } from "../components/ListInput";
import { Pagination } from "../components/Pagination";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import { FiTrash } from "react-icons/fi";
import { ConfirmButton } from "../components/ConfirmButton";
import { User } from "../types/user";

export const UsuarioList = () => {
  useIsAuth();

  const usuarios = useSelector((state: RootState) => state.sistema.usuarios);
  const isLoading = useSelector((state: RootState) => !!state.sistema.isLoading);
  const success = useSelector((state: RootState) => !!state.sistema.success);
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const [termo, setTermo] = useState("");

  useEffect(() => {
    dispatch(sistemaActions.usuariosRequest({
      page,
      termo,
    }))
  }, [dispatch, page, termo])

  useEffect(() => {
    if (!success) {
      return;
    }
    dispatch(sistemaActions.usuariosRequest({
      page,
      termo,
    }))
  }, [dispatch, success, page, termo])

  const headers: TableHeaders<User>[] = [
    {
      label: "Id",
      wrapped: true,
      render: (item) => item.id,
    },
    {
      label: "Nome",
      wrapped: false,
      render: (item) => item.name,
    },
    {
      label: "E-mail",
      wrapped: false,
      render: (item) => item.email
    },
    {
      label: "Celular",
      wrapped: true,
      render: (item) => item.celular
    },
    {
      label: "Ativo?",
      wrapped: true,
      render: (item) => item.ativo == '1' ? 'Sim' : 'Não',
    },
    {
      label: "Administrador?",
      wrapped: true,
      render: (item) => item.e_administrador == '1' ? 'Sim' : 'Não',
    },
    {
      label: "Ações",
      wrapped: true,
      render: (item, index) => <>{<ConfirmButton confirm={() => onDeleteItem(item.id as number)}><FiTrash /></ConfirmButton>}</>,
      notClicable: true,
    },
  ];

  const onDeleteItem = (id: number) => {
    dispatch(sistemaActions.deleteUsuariosRequest(id));
  }

  const navigate = useNavigate();

  return (
    <Layout>
      <ListHeader label="Usuários">
        <DefaultButton ml={4} to="/usuarios/novo"> Novo </DefaultButton>
      </ListHeader>

      <Loader isLoading={isLoading} />

      <ListInput label="Filtrar por nome, email ou celular" onSubmit={setTermo} />

      {usuarios && <ResponsiveTable onClick={(item: any) => navigate(`/usuarios/${item.item.id}`)} headers={headers} data={usuarios.data} />}

      {usuarios && <Pagination info={usuarios} paginate={setPage} />}
    </Layout>
  )
}